export default __webpack_public_path__ + "static/media/Achiton of Celestial Radiance.f036f4e0.jpg";